import { useSelector, useDispatch } from "react-redux"
import { login, logout } from "./AuthSlice"
import axios from "axios"

export const useAuth = () => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.auth.user)
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn)

  const signIn = (userData) => dispatch(login(userData))
  const signOut = async () => {
    try {
      await axios.post("/api/auth/logout", { withCredentials: true })
    } catch (error) {
      console.warn("Logout error:", error)
    } finally {
      dispatch(logout())
    }
  }

  return { user, isLoggedIn, signIn, signOut }
}
